<template>
    <div>
        <b-card class="loginFormCard mt-4">
            <h2 slot="header">Вход в DriveCRM</h2>

            <form class="loginForm" @submit.prevent="login">
                <div class="form-group">
                    <label for="userName">Имя пользователя</label>
                    <input id="userName" class="form-control" required v-model="username" type="text"
                           placeholder="Введите ваше имя пользователя"/>
                </div>
                <div class="form-group">
                    <label for="password">Пароль</label>
                    <input id="password" class="form-control" required v-model="password" type="password"
                           placeholder="Пароль"/>
                </div>
                <hr/>
                <button class="btn btn-primary" type="submit">Войти</button>
            </form>
        </b-card>
    </div>
</template>

<style>
    .loginFormCard {
        width: 300px;
        margin: 0 auto;
    }

    .loginForm {
        display: flex;
        flex-direction: column;

        padding: 10px;
        margin: 0 auto;
    }
</style>

<script>
    import {AUTH_REQUEST} from '../../store/actions/auth.js'

    export default {
        name: 'login',
        data() {
            return {
                username: '',
                password: '',
            }
        },
        methods: {
            login: function () {
                const {username, password} = this;
                this.$store.dispatch(AUTH_REQUEST, {username, password}).then(() => {
                    this.$router.push('/')
                })
            }
        },
    }
</script>